import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Arrow from '../Arrow';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import './ToggleSelector.css';
import { DetailsContext } from '../../context/detailsContext';
import { tracking, tagType } from '../../utils/tracking';
import { messages as text } from '../../messages';

function ToggleNav({ onClick, active }) {
  // Set active class when menu is active
  const toggleButtonClass = classNames('toggle-topicSelector', {
    active,
    closed: !active,
  });

  const { currentIndex } = useContext(DetailsContext);

  const _onClick = () => {
    tracking(
      tagType.event,
      text[`topic${currentIndex}Title`].defaultMessage,
      'CLICK',
      'In-page click',
      `${text.topicSelectorLabel.defaultMessage}:${
        active.toString() === 'false' ? 'Open' : 'Close'
      }`,
    );
    onClick();
  };

  const ariaLabel = active
    ? 'Click to close menu'
    : 'Click to go to menu of individual benefits that can be clicked on to learn more';

  return (
    <button
      aria-label={ariaLabel}
      onClick={_onClick}
      className={toggleButtonClass}
      type="button">
      <span>
        <FormattedMessage id="topicSelectorLabel" />
        <Arrow />
      </span>
    </button>
  );
}

ToggleNav.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
};

export default ToggleNav;
